﻿import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { Configuration } from "Configuration/Configuration";
import "./Styles/global.scss";
import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, LineElement, PointElement, Tooltip, Legend, Filler } from "chart.js";
import "Helpers/ArrayExtensions";
import { ApiClientProvider } from "./Contexts/ApiClientContext";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, LineElement, PointElement, Filler);

Configuration.refresh()
    .then(() => {
        // const configuration = Configuration.get();
        // appInsights.config.correlationHeaderDomains = [UrlHelper.host(configuration.adminApiUri!), UrlHelper.host(configuration.adminAppUri!)];

        const container = document.getElementById("root")!;
        const root = createRoot(container);
        root.render(
            <BrowserRouter>
                <ApiClientProvider>
                    <App />
                </ApiClientProvider>
            </BrowserRouter>
        );
    });